import { Fragment } from 'react';

import _ from 'lodash';

import moment from 'moment';

import PropTypes from 'prop-types';

import { FadeInAnimation } from '../../shared';

const BuildingReviews = (props) => {
    
    const { selectedBuilding, buildingContentCMS } = props;

    const buildingReviews = _.get(buildingContentCMS, 'acf.review');
    const buildingId = _.get(selectedBuilding, 'id');
    const buildingName = _.get(selectedBuilding, 'name');

    const renderReviews = () => {
        return _.map(buildingReviews, (review, index) => {
            const buildingIdFromCMS = _.get(review, 'building_id');
            const title = _.get(review, 'title');
            const description = _.get(review, 'description');
            const person = _.get(review, 'person');
            const date = _.get(review, 'date_of_review');
            let formattedDate = moment() - moment(date);
            formattedDate = moment(formattedDate).format('M');
            const stars = _.get(review, 'star_count');

            if (_.lowerCase(buildingId) === _.lowerCase(buildingIdFromCMS)) {
                return (
                    <Fragment key={index}>
                        <FadeInAnimation>
                            <div>
                                {renderStars(stars)}

                                <h4 className='building-reviews-title'>&apos;{title}&apos;</h4>
                                <p className='building-reviews-paragraph'>{description}</p>
                                <p className='building-reviews-person'>
                                    {person} - {formattedDate} months ago
                                </p>
                            </div>
                        </FadeInAnimation>
                    </Fragment>
                );
            }
            return null;
        });
    };

    const renderStars = (starCount) => {
        const maxStars = 5;
        const starDifference = maxStars - starCount;
        const stars = [];
        for (let i = 0; i < starCount; i += 1) {
            stars.push(<img key={i} src="/assets/images/full_star.png" alt="yellow-start" className='building-reviews-img' />);
        }
        if (starDifference > 0) {
            for (let i = 0; i < starDifference; i += 1) {
                stars.push(
                    <img
                        key={maxStars - starDifference + i}
                        src="/assets/images/empty_star.png"
                        alt="grey-start"
                        className='building-reviews-img'
                    />,
                );
            }
        }

        return stars;
    };

    return (
        <FadeInAnimation>
            <div id="review-section">
                <h3 className='building-reviews-header3'>Reviews of {buildingName}</h3>
                {renderReviews()}
            </div>
        </FadeInAnimation>
    );
};

export default BuildingReviews;

BuildingReviews.propTypes = {
    selectedBuilding: PropTypes.object,
    buildingContentCMS: PropTypes.object,
};

